<template>
    <div>
        <v-progress-linear
        v-if="mostrar"
        indeterminate
        :color="configuracion.color"
        ></v-progress-linear>
    </div>
</template>
<script>
export default {
    data:()=>({
        configuracion:{},
        mostrar:false
    }),
    beforeDestroy() {
        Event.$off('iniciar');
        Event.$off('terminar');
    },
    mounted(){
        this.$parent.$on('iniciar',configuracion=>{
            console.log('holi',configuracion);
            this.configuracion = configuracion;
            this.mostrar = true;
        });
        this.$parent.$on('terminar',()=>{
            this.configuracion = {};
            this.mostrar = false;
        });
    }
}
</script>